//@flow
import * as React from 'react';
import moment from 'moment';
import classnames from 'classnames';

const difficultyLetters = ['?', 'E', 'M', 'D'];
export function getDifficultyLetterFromDifficultyNumber(number: ?number): string {
  if (!number || !difficultyLetters[number]) {
    return '?';
  }
  return difficultyLetters[number];
}

export function getDifficultySpan(
  difficultyNumber: ?number,
  showAsDisabled: ?boolean = undefined
): React.Node {
  const showDisabled = showAsDisabled || false;

  const difficultyLetter = getDifficultyLetterFromDifficultyNumber(difficultyNumber);
  return (
    <div
      className={classnames(
        'insight-table__question-info-difficulty-badge',
        'question-set-difficulty-badge',
        {
          easy: difficultyLetter === 'E',
          moderate: difficultyLetter === 'M',
          difficult: difficultyLetter === 'D',
          disabled: showDisabled
        }
      )}
    >
      <span />
    </div>
  );
}

export function getFormattedDurationTimeFromStamp(timeElapsed): string {
  const momentDuration = moment.duration(timeElapsed);
  const minutes = momentDuration.asMinutes();
  const flooredMinutes = Math.floor(minutes);
  if (flooredMinutes === 0) {
    return `${Math.floor(momentDuration.asSeconds())}s`;
  } else if (flooredMinutes <= 20) {
    return `${flooredMinutes}m`;
  } else {
    return '>20m';
  }
}
